import React from 'react';
import { connect } from 'react-redux';
import { List, Iterable } from 'immutable';
import { CRUDVerbs } from './constants';
import { generateCRUDAction } from './actions';
import capitalFirstLetter from '../helpers/capital-first-letter';

export default function connectResource(name) {
  const capitalName = capitalFirstLetter(name);

  function mapStateToProps(state) {
    return {
      resources: state.resources,

      [`get${capitalName}`]: () => {
        const resourceType = state.resources.get(name);

        if (!resourceType) {
          return new List();
        }

        return resourceType;
      },

      [`get${capitalName}ByIds`]: ids => {
        if (!Iterable.isIterable(ids)) {
          throw new Error('`ids` should be an iterable.');
        }
        const resourceType = state.resources.get(name);

        if (!resourceType) {
          return new List();
        }

        // const idsSet = ids.toSetSeq();
        return resourceType.filter(r => ids.toSetSeq().has(r.get('id')));
      },
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      [`load${capitalName}`]: () => {
        dispatch(generateCRUDAction(name, CRUDVerbs.READ)({ resource: name }));
      },
      [`load${capitalName}ByIds`]: ids => {
        if (!Iterable.isIterable(ids)) {
          throw new Error('`ids` is not iterable.');
        }
        dispatch(generateCRUDAction(name, CRUDVerbs.READ)({ ids, resource: name }));
      },
    };
  }

  return WrappedComponent => {
    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name;

    const ConnectResource = props => <WrappedComponent {...props} />;

    ConnectResource.displayName = `ConnectResource(${wrappedComponentName})`;

    return connect(
      mapStateToProps,
      mapDispatchToProps
    )(ConnectResource);
  };
}
